<template>
<div id="page-playlist" class="container-fluid">
    <div class="row">
        <div class="col-xs-12 header">
            <div class="button button-center back" @click="$router.back()"><i class="iconify icon:ic:round-keyboard-backspace"></i></div>
            
            <div class="btn button button-white set-default" @click="setAsProfile()" v-if="playlist.id && !isProfile">SET AS PROFILE DEFAULT</div>
            <div class="btn button button-white set-default" @click="removeAsProfile()" v-if="playlist.id && isProfile">RESET</div>
        </div>

        <div class="col-xs-12 actions">
            <div class="play" v-show="!playing" @click="play()"><span class="iconify icon:ic:outline-play-circle-filled"></span></div>
            <div class="pause" v-show="playing" @click="pause()"><span class="iconify icon:ic:sharp-pause-circle-outline"></span></div>
            <div class="button button-center button-white next"><span class="iconify icon:ic:outline-skip-next"></span></div>
            <div class="button button-center button-white prev"><span class="iconify icon:ic:outline-skip-previous"></span></div>
        </div>

        <div class="col-xs-12 info">
            <p class="name">{{ playlist.name }}</p>
            <p class="owner">BY {{ playlist.user.name }}</p>
            <p v-if="!isDefault" class="details">{{ playlist.songs.length }} songs / updated on {{updatedAt}}.</p>
            <p v-if="isDefault" class="details">&nbsp;</p>
        </div>

        <div class="col-xs-12 content">
            <ul class="page-tabs text-center">
                <li @click="changeTab('#songs')" :class="{'active' : isTab('#songs')}">Songs</li>
                <li v-if="!isDefault" @click="changeTab('#statistics')" :class="{'active' : isTab('#statistics')}">Statistics</li>
                <li v-if="!isDefault" @click="changeTab('#share')" :class="{'active' : isTab('#share')}">Share</li>
            </ul>
        </div>

        <div class="col-xs-12 tab-content no-padding" style="min-height: 400px;" v-if="playlist.id">
            <tab-songs v-if="isTabRendered('#songs') && playlist" v-show="isTab('#songs')" :playlist="playlist"></tab-songs>
            <tab-statistics v-if="isTabRendered('#statistics') && playlist" v-show="isTab('#statistics')" :playlist="playlist"></tab-statistics>
            <tab-share v-if="isTabRendered('#share') && playlist" v-show="isTab('#share')" :playlist="playlist"></tab-share>
        </div>
        
        <div class="clearfix"></div>
    </div>
</div>
</template>

<script>
export default {
    components: {
        'tab-songs': require('@/components/Playlists/PlaylistTabSongs.vue').default,
        'tab-statistics': require('@/components/Playlists/PlaylistTabStatistics.vue').default,
        'tab-share': require('@/components/Playlists/PlaylistTabShare.vue').default,
        'loader': require('@/components/Loader.vue').default,
    },

    props: ['playlistId'],

    data() {
        return {
            playlist: {
                id: 0,
                name: null,
                user: { name: null },
                songs: {}
            },
            isProfile: false,
            tab: {
                active:'#songs',
                rendered: {
                    '#songs': false,
                    '#statistics': false,
                    '#share': false
                }
            },

            playing: false,
        }
    },  

    mounted() {
        this.tab.active = this.$router.currentRoute.hash ? this.$router.currentRoute.hash : this.tab.active;
        this.tab.rendered[this.tab.active] = true;

        this.changeTab('#songs', false);

        if ( this.isDefault ){
            this.playlist = {
                id: this.playlistId,
                name: this.playlistId == 'disliked' ? 'Disliked Songs' : 'Liked Songs',
                songs: {},
                user: App.user
            }

            if (App.allowGtag) gtag('config', 'UA-152097964-2', {
                'page_path' : "/playlist/" + this.playlistId,
                'page_location': "/playlist/" + this.playlistId,
                'page_title' : "Playlist > " + this.playlist.name
            });

            if (App.allowGtag) gtag('event', 'open_playlist', {
                'event_category' : 'playlist',
                'event_label' : `Open own playlist`
            });
        }else{
            this.$http.get(this.getPlaylistEndpoint).then((success) => {
                this.playlist = success.data.data;
                this.isProfile = this.playlist.id == localStorage.getItem("default-playlist-"+ App.user.id);

                if (App.allowGtag) gtag('event', 'open_playlist', {
                    'event_category' : 'playlist',
                    'event_label' : `Open ${ this.playlist.user.id == App.user.id ? 'own' : 'other' } playlist`
                });                    
            });

            if (App.allowGtag) gtag('config', 'UA-152097964-2', {
                'page_path' : "/playlist",
                'page_location': "/playlist",
                'page_title' : "Playlist"
            });
        }
    },

    methods: {
        isTab(tab) {
            return this.tab.active == tab;
        },

        isTabRendered(tab) {
            return this.tab.rendered[tab];
        },

        changeTab(tab, scroll = true) {
            this.tab.active = tab;
            this.tab.rendered[tab] = true;
            this.$nextTick(() => {
                if (scroll) $('main').animate({scrollTop: $('main')[0].scrollHeight }, 500);
            });

            if (App.allowGtag) gtag('config', 'UA-152097964-2', {
                'page_path' : "/playlist/" + tab.slice(1),
                'page_location': "/playlist/" + tab,
                'page_title' : "Playlist > " + tab.charAt(1).toUpperCase() + tab.slice(2),
            });
        },

        play(){
            this.playing = true;
            this.$root.$emit('play-all');
        },

        pause(){
            this.playing = false;
            this.$root.$emit('playerAction', 'pause');
        },

        setAsProfile(){
            this.isProfile = true;
            localStorage.setItem("default-playlist-"+ App.user.id, this.playlist.id);
            this.$root.$emit('forcePageReload');
        },

        removeAsProfile(){
            this.isProfile = false;
            localStorage.removeItem("default-playlist-"+ App.user.id);
            this.$root.$emit('forcePageReload');
        },

        back(){
            this.$router.back();
        }
    },

    computed: {
        getPlaylistEndpoint() {
            return App.restApi + '/api/v2/playlists/' + this.playlistId;
        },

        getImage() {
            return App.restApi + '/api/image/' + this.playlist.image_name;
        },

        profileImage(){
            return this.playlist.user.profile_image_direct_url ? this.playlist.user.profile_image_direct_url : '/img/web/default-avatar.svg';
        },

        isDefault() {
            return isNaN(this.playlistId);
        },

        updatedAt() {
            return this.playlist.updated_at ? moment(this.playlist.updated_at).format('MMM D, YYYY') : "";
        }
    },

    watch: {
 
    }    
}
</script>